import React, { useMemo } from 'react';
import { styled, useStyleConfig, vui } from '../core';
import List from '../list';
import { cs, filterUndefined } from '../utils';
import AccordionItem from './accordionItem';
import AccordionItemHorizontal from './accordionItemHorizontal';
import { AccordionProvider } from './context';
export const AccordionBase = styled.divBox `
  display: flex;
  min-width: 0;
  transition-duration: normal;
`;
/** Allows to show and hide sections of related content on a page. */
export const Accordion = vui((props, ref) => {
    const { children, className, itemTitleHoverBg = 'blue.10', items, orientation = 'vertical', size, ...rest } = props;
    const styles = useStyleConfig('Accordion', props);
    const context = useMemo(() => filterUndefined({ size }), [size]);
    const aliasedProps = filterUndefined({});
    return (React.createElement(AccordionProvider, { value: context },
        React.createElement(AccordionBase, { className: cs('vui-accordion', className), ref: ref, ...styles, ...aliasedProps, ...rest }, orientation === 'vertical' ? (React.createElement(List, { w: "100%" }, items
            ? items?.map?.((item, key) => (React.createElement(AccordionItem, { itemTitleHoverBg: itemTitleHoverBg, key: key, ...item })))
            : children)) : items ? (items?.map?.((item, key) => (React.createElement(AccordionItemHorizontal, { itemTitleHoverBg: itemTitleHoverBg, key: key, ...item })))) : (children))));
});
Accordion.Item = AccordionItem;
Accordion.ItemHorizontal = AccordionItemHorizontal;
export default Accordion;
